export interface AttendingToggleProps {
  /** Who is being asked about — names the group and each button. */
  name: string;
  /** true coming, false not coming, null not answered (neither pressed). */
  coming: boolean | null;
  onChange: (coming: boolean) => void;
  /** A colour to mark the pressed answer in (an invitation's accent); else the app's. */
  accent?: string;
}

const OPTIONS = [
  { value: true, label: 'Coming' },
  { value: false, label: 'Not coming' },
] as const;

/**
 * Coming / Not coming for one named person in a party — on the public RSVP
 * page, the guest form and the office's RSVP override alike.
 */
export function AttendingToggle({ name, coming, onChange, accent }: AttendingToggleProps) {
  return (
    <div className="flex shrink-0 gap-1.5" role="group" aria-label={`Is ${name} coming?`}>
      {OPTIONS.map((option) => {
        const pressed = coming === option.value;
        return (
          <button
            key={option.label}
            type="button"
            aria-label={`${name} ${option.label.toLowerCase()}`}
            aria-pressed={pressed}
            onClick={() => onChange(option.value)}
            className={`px-3 py-1.5 rounded-lg border text-xs font-medium ${
              pressed
                ? accent
                  ? ''
                  : 'border-primary-600 bg-primary-50 text-primary-700'
                : 'border-gray-200 text-gray-600 hover:border-gray-300'
            }`}
            style={
              pressed && accent
                ? { borderColor: accent, color: accent, backgroundColor: `${accent}14` }
                : undefined
            }
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
